import axios from "axios";
import qs from "qs";
import { api } from "@/plugins/util";

export function getUnitUserList({
                                   name,
                                   mobile,
                                    userType,
                                    userStatus,
                                    dept,
                                    pageNum
                               }) {
    return axios.get(api + "/yxdwUser/list", {
        params: {
            name,
            mobile,
            userType,
            userStatus,
            dept,
            pageNum
        }
    });
}
export function getUnitUserList2({
                                    name,
                                    mobile,
                                    userStatus,
                                    pageNum
                                }) {
    return axios.get(api + "/yxdwUser/list2", {
        params: {
            name,
            mobile,
            userStatus,
            pageNum
        }
    });
}
export function addYxdwUser({ name, mobile,
                                yxdwId, dept,userType,station,sex,region  }) {
    return axios.post(api + "/yxdwUser/add", qs.stringify({
        name, mobile,
        yxdwId,
            dept,
            userType,
            station,
            sex,
            region

    })
    );
}
export function addYxdwUser2({ name, mobile,
                                 dept,area,station,sex,address,region  }) {
    return axios.post(api + "/yxdwUser/add2", qs.stringify({
            name, mobile,
             dept,area,station,sex,address,region

        })
    );
}
export function updateYxdwUser({ id, name, mobile, yxdwId,
    yxdw, dept,userType,station,sex,region  }) {
    return axios.post(api + "/yxdwUser/update", qs.stringify({
            id,
            name, mobile, yxdwId,
            yxdw, dept,userType,station,sex,region
        })
    );
}
export function updateYxdwUser2({ id, name, mobile,
                                    dept,area,station,sex,address,region   }) {
    return axios.post(api + "/yxdwUser/update2", qs.stringify({
            id,
            name, mobile,
             dept,area,station,sex,address,region
        })
    );
}
export function enableYxdwUser(ids) {
    return axios.post(api + "/yxdwUser/enable", qs.stringify({
            ids
        })
    );
}

export function disableYxdwUser(ids) {
    return axios.post(api + "/yxdwUser/disable", qs.stringify({
            ids
        })
    );
}

export function resetPassword(mobile) {
    return axios.post(api + "/yxdwUser/resetPassword", qs.stringify({
            mobile
        })
    );
}


